// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initTranslations } from './components/translations';

// 🌍 Versão atual do Service Worker
const SW_VERSION = 'v2.10-hybrid';
const SW_SCRIPT = '/sw-tile-cache.js';

// ✅ CORREÇÃO: Verifica versão no CACHE, não na URL do script
async function cleanOldServiceWorkers() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const cacheNames = await caches.keys();
    
    // Verifica se há caches da versão antiga (apenas caches do app-shell e heatmap)
    const hasOldCache = cacheNames.some(name => 
      (name.includes('app-shell-') || name.includes('heatmap-data-')) && 
      !name.includes(SW_VERSION)
    );

    if (hasOldCache) {
      // console.log('[SW] 🧹 Detectado cache antigo - removendo...');
      
      // Remove caches antigos
      for (const name of cacheNames) {
        if ((name.includes('app-shell-') || name.includes('heatmap-data-')) && !name.includes(SW_VERSION)) {
          await caches.delete(name);
          // console.log('[SW] 🗑️ Cache removido:', name);
        }
      }

      // Remove registros antigos (APENAS se houver cache antigo)
      for (const registration of registrations) {
        await registration.unregister();
        // console.log('[SW] 🔄 SW desregistrado para atualização');
      }
    } else {
      // console.log('[SW] ✅ Versão atual detectada:', SW_VERSION);
    }
  } catch (err) {
    console.error('[SW] ❌ Erro ao limpar SWs antigos:', err);
  }
}

// Executa limpeza ANTES de renderizar
cleanOldServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById('root'));

async function startApp() {
  await initTranslations();
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

startApp();

// ✅ Registro do Service Worker com controle de atualização melhorado
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_SCRIPT)
      .then(registration => {
        // console.log('✅ Service Worker registrado:', registration.scope);

        // Força atualização se houver nova versão disponível
        registration.update().catch(() => {});

        // Detecta atualizações
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // console.log('🆕 Nova versão disponível - ativando...');
              
              // Avisa o novo SW para ativar imediatamente
              newWorker.postMessage({ type: 'SKIP_WAITING' });
              
              // Aguarda ativação e recarrega UMA ÚNICA VEZ
              navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (!sessionStorage.getItem('sw_reloaded')) {
                  sessionStorage.setItem('sw_reloaded', 'true');
                  window.location.reload();
                }
              }, { once: true });
            }
          });
        });
      })
      .catch(err => console.error('❌ Erro ao registrar SW:', err));
  });

  // Limpa flag de reload ao fechar a aba
  window.addEventListener('beforeunload', () => {
    sessionStorage.removeItem('sw_reloaded');
  });
}

reportWebVitals();

